import { render, staticRenderFns } from "./hotQuestions.vue?vue&type=template&id=eaa85b0a&scoped=true"
import script from "./hotQuestions.vue?vue&type=script&lang=js"
export * from "./hotQuestions.vue?vue&type=script&lang=js"
import style0 from "./hotQuestions.vue?vue&type=style&index=0&id=eaa85b0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa85b0a",
  null
  
)

export default component.exports